<div class="dish" [class.not-avail]="!schedule_active || !available">
  <div *ngIf="image" class="img">
    <img [src]="image" class="ya_image">
  </div>
  <div *ngIf="!image" class="img noimg">
    <h3>{{title}}</h3>
  </div>
  <div class="content container">
    <div class="top">
      <header>
        <h2 [truncatedText]="title"></h2>
      </header>
    </div>
    <footer>
      <div class="preis">{{price | price}}</div>
      <a class="btn insert">
        <div inlineSVG="sot/sot-icon.svg#sot-done" flex [setSVGAttributes]="{class: 'icon'}"></div>
      </a>
    </footer>
    <ng-container *ngIf="!schedule_active">
      <div class="not-available">
        <span>{{schedule_hint}}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="schedule_active && !available">
      <div class="not-available">
        <span langkey="details_not_available"></span>
      </div>
    </ng-container>
  </div>
</div>